/**
 * Shared CSV-import contract constants that MUST stay byte-for-byte identical
 * across the API (which emits them) and the web review UI (which parses them).
 * They live here, in the package both sides already depend on, so the contract
 * is one constant rather than two literals coupled only by a comment.
 */

/**
 * Prefix of the row warning the animals CSV validator emits for a fuzzy buyer
 * match (SUP-337 task 3). The web review step keys off this exact string to
 * decide a warning is a buyer-match flag (and render the resolve-in-review
 * typeahead / create-new controls), so this is the single source of truth.
 */
export const BUYER_MATCH_WARNING_PREFIX = 'Possible existing buyer match:';
